import axios from 'axios';

export default function finishProject({ id, authToken }) {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/project/${id}/finish`,
      {},
      {
        validateStatus: (status) => status === 200,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
    .then((result) => result.data.result);
}
